import axios from '@/axios'

const RESOURCE_NAME = '/ai-sequences';

export default {
    getLoadingText(name) {
        return axios.post(`${RESOURCE_NAME}/get-loading-text?name=${name}`)
    },
}
